import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Select from 'react-select';
import { RegisterContext } from '../../contexts/RegisterContext';
import * as referenceService from '../services/referenceService';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';

export function AdminPendingRating() {


    const { user } = useContext(AuthContext);
    const [resultData, setResultData] = useState([]);
    const { schools } = useContext(RegisterContext);
    const [filter, setFilter] = useState({
        schoolFirst: '',
        contains: '',
        schoolFirstCheck: false,
        containsCheck: false,
        childrenWithDisabilities: false
    });
    const [filteredData, setFilteredData] = useState([]);
    const [schoolsOptions, setSchoolsOptions] = useState([{ id: 0, name: 'Всички', shortName: 'Всички' }, ...schools]);

    useEffect(() => {
        try {
            referenceService.getSchoolRanking(0, user.role == 'Director' ? user.school.id : 0)
                .then((res) => {
                    setResultData(res);
                    setFilteredData(res)
                })
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }

        document.title = `Чакащи класиране`;
    }, []);

    useEffect(() => {
        setSchoolsOptions([{ id: 0, name: 'Всички', shortName: 'Всички' }, ...schools]);
    }, [schools])

    const selectedSchoolTemplate = (option, props) => {
        if (option && option.shortName !== 'Всички') {
            return (
                <div className="flex align-items-center  font">
                    <div>{option.shortName}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const streetSchoolTemplate = (option) => {
        return (
            <div className="flex align-items-center  font">
                <div>{option.shortName}</div>
            </div>
        );
    };

    const handleChange = (e) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (fieldName == 'firstWish') {

            if (fieldValue.shortName == 'Всички') {
                setFilteredData(resultData)
            } else {
                setFilteredData(state => resultData.filter(x => x.schools[0] == fieldValue.shortName))
            }

            setFilter(state => ({
                schoolFirst: fieldValue
            }))
        } else if (fieldName == 'containsSchool') {
            if (fieldValue.shortName == 'Всички') {
                setFilteredData(resultData)
            } else {
                setFilteredData(state => resultData.filter(x => x.schools.includes(fieldValue.shortName)))
            }

            setFilter(state => ({
                contains: fieldValue
            }))
        }
    }

    const handleCheckboxChange = (e, option) => {
        let filteredData = [...resultData]; 

        if (!e.target.checked) {
            setFilteredData(filteredData); 
            setFilter(prevOptions => ({
                ...prevOptions,
                containsCheck: false,
                schoolFirstCheck: false,
                childrenWithDisabilities: false
            }));
        } else {
            if (option === 'firstWish') {
                filteredData = filteredData.filter(x => x.schools[0] === user.school.shortName);
                setFilter(prevOptions => ({
                    ...prevOptions,
                    childrenWithDisabilities: false,
                    schoolFirstCheck: true,
                }));
            } else if (option === 'childrenWithDisabilities') {
                filteredData = resultData.filter(x => x.desires.some(d => d.k110 == 1));
                setFilter(prevOptions => ({
                    ...prevOptions,
                    childrenWithDisabilities: true,
                    schoolFirstCheck: false,
                }));
            }
            setFilteredData(filteredData);
        }
    }

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Чакащи класиране</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Чакащи класиране</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">
                    {user.role !== 'Director' ?
                        <>
                            <div className="col-lg-4 mb-4 w-100-mob w-40-l">
                                <Dropdown
                                    name="firstWish"
                                    value={filter.schoolFirst}
                                    className="col_school_dropdown prime-dropdown-heigth  font w-100-mob"
                                    options={schoolsOptions}
                                    optionLabel="name"
                                    filter
                                    placeholder='Чакащи по първо желание'
                                    valueTemplate={selectedSchoolTemplate}
                                    itemTemplate={streetSchoolTemplate}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-lg-4 mb-4 w-100-mob w-40-l">
                                <Dropdown
                                    name="containsSchool"
                                    value={filter.contains}
                                    className="col_school_dropdown prime-dropdown-heigth  font w-100-mob"
                                    options={schoolsOptions}
                                    optionLabel="name"
                                    filter
                                    placeholder='Съдържащи училище в желанията си'
                                    valueTemplate={selectedSchoolTemplate}
                                    itemTemplate={streetSchoolTemplate}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <Checkbox
                                    inputId="childrenWithDisabilities"
                                    onChange={(e) => handleCheckboxChange(e, 'childrenWithDisabilities')}
                                    checked={filter.childrenWithDisabilities}
                                />
                                <label htmlFor="isHaveSchoolInWishes" >
                                    Дете с трайни увреждания над 50 %
                                </label>
                            </div>
                        </>
                        : <div className="d-flex w-60  justify-content-between align-items-center flex-wrap w-100-mob gap-2">
                            <div className="d-flex gap-2">
                                <Checkbox
                                    inputId="firstWish"
                                    onChange={(e) => handleCheckboxChange(e, 'firstWish')}
                                    checked={filter.schoolFirstCheck}
                                />
                                <label htmlFor="registerByMe">
                                    Чакащи по първо желание
                                </label>
                            </div>
                            <div className="d-flex gap-2">
                                <Checkbox
                                    inputId="childrenWithDisabilities"
                                    onChange={(e) => handleCheckboxChange(e, 'childrenWithDisabilities')}
                                    checked={filter.childrenWithDisabilities}
                                />
                                <label htmlFor="isHaveSchoolInWishes" >
                                    Дете с трайни увреждания над 50 %
                                </label>
                            </div>
                        </div>
                    }

                    <div className="col-lg-12">

                        <div className="row mt-5">
                            {resultData.length > 0 ?
                                <table className="table table-striped table-hover w-100">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Рег.Номер</th>
                                            <th scope="col">ЕГН/ЛНЧ</th>
                                            <th scope="col">ИМЕ</th>
                                            <th scope="col">Желания</th>
                                            <th scope="col">СТАТУС</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {

                                            filteredData.map((r, index) => (
                                                <tr key={index + 1}>
                                                    <td>{index + 1}</td>
                                                    <td>{r.regnumbeR_ID}</td>
                                                    <td>{r.childEgn}</td>
                                                    <td>
                                                        {r.childName}
                                                        {r.childName2 && <br />}
                                                        {r.childName2}
                                                        {r.childName3 && <br />}
                                                        {r.childName3}
                                                        {r.childName4 && <br />}
                                                        {r.childName4}
                                                    </td>
                                                    <td>
                                                        {
                                                            r.schools.map((s, ind) => (
                                                                <span key={ind}>
                                                                    {ind + 1} - {s}
                                                                    {ind !== s.length - 1 && <br />}
                                                                </span>
                                                            ))
                                                        }
                                                    </td>

                                                    <td>Чакащо класиране</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                : "Няма деца които чакат за класиране."
                            }
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminPendingRating;